import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ClothingCatalogItem,
  ClothingCatalogItemPayload
} from '../../../models/clothing.model';
import {
  CLOTHING_SEASONS,
  ClothingSelectOption
} from './clothing.constants';

export const CLOTHING_CATALOG_MODAL_ACTIONS = {
  save: 'save',
  deactivate: 'deactivate'
};

export interface ClothingCatalogModalResult {
  action: string;
  payload?: ClothingCatalogItemPayload;
}

@Component({
  selector: 'app-clothing-catalog-modal',
  templateUrl: './clothing-catalog-modal.component.html',
  styleUrls: ['./clothing-catalog-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClothingCatalogModalComponent {
  titleKey = 'CLOTHING_CREATE_ITEM';
  itemId = '';
  catalogForm = this.createCatalogForm();
  seasons: ClothingSelectOption[] = CLOTHING_SEASONS;

  constructor(
    public activeModal: NgbActiveModal,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  get isEditing(): boolean {
    return this.itemId.length > 0;
  }

  setCreateMode() {
    this.itemId = '';
    this.titleKey = 'CLOTHING_CREATE_ITEM';
    this.catalogForm = this.createCatalogForm();
    this.markForCheck();
  }

  setEditMode(item: ClothingCatalogItem) {
    this.itemId = item.id;
    this.titleKey = 'CLOTHING_EDIT_ITEM';
    this.catalogForm = this.createCatalogPayload(item);
    this.markForCheck();
  }

  save() {
    this.activeModal.close({
      action: CLOTHING_CATALOG_MODAL_ACTIONS.save,
      payload: this.buildPayload()
    });
  }

  deactivate() {
    this.activeModal.close({
      action: CLOTHING_CATALOG_MODAL_ACTIONS.deactivate
    });
  }

  close() {
    this.activeModal.dismiss();
  }

  trackBySeason(index: number, option: ClothingSelectOption): string {
    return option.value;
  }

  private createCatalogForm(): ClothingCatalogItemPayload {
    return {
      name: '',
      season: CLOTHING_SEASONS[0].value,
      serviceLifeWorkingDays: 1,
      priceUsd: 0,
      mandatory: false
    };
  }

  private createCatalogPayload(item: ClothingCatalogItem): ClothingCatalogItemPayload {
    return {
      name: item.name,
      season: item.season,
      serviceLifeWorkingDays: item.serviceLifeWorkingDays,
      priceUsd: item.priceUsd,
      mandatory: item.mandatory
    };
  }

  private buildPayload(): ClothingCatalogItemPayload {
    return {
      name: this.catalogForm.name.trim(),
      season: this.catalogForm.season,
      serviceLifeWorkingDays: Number(this.catalogForm.serviceLifeWorkingDays),
      priceUsd: Number(this.catalogForm.priceUsd),
      mandatory: this.catalogForm.mandatory
    };
  }

  private markForCheck() {
    this.changeDetectorRef.markForCheck();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-catalog-modal.component.ts